export enum EventStatus {
  Verified = 'verified',
  NotVerified = 'not_verified',
  SoftDelete = 'soft_delete',
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace EventStatus {
  export function toColor(
    status: EventStatus,
  ): 'success' | 'danger' | 'warning' {
    if (status === EventStatus.Verified) {
      return 'success'
    } else if (status === EventStatus.NotVerified) {
      return 'warning'
    } else {
      return 'danger'
    }
  }
}
